$(document).ready(function () {

	$('form[name="form"]').slick();

	if($('button.magazine-viewer-link').length > 0){
		$('button.magazine-viewer-link').on("click", function(){
			$('form#magazine_viewer').submit();
		});
	}

	$('div.menu-btn').on('click', function(){
		$('#mobile-nav-wrapper').addClass("active");
	});

	$('li.close-menu').on('click', function(){
		$('#mobile-nav-wrapper').removeClass("active");
    });

	$('li.menu-item-has-children').each(function(k,v){
		$(v).on('click', function(){
			var sublist = $(this).children('ul.dropdown');
			if($(sublist).hasClass('active')){
				$(sublist).removeClass('active');
			}else{
				$(sublist).addClass('active');
			}
		});
	});

	$('.slider').each(function(k,v) {
		$(v).slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: false,
			pauseOnHover: false
		});
	});

	$('.slider-fast').each(function(k,v) {
		$(v).slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			pauseOnHover: false
		});
	});

	$('.slider-advert').each(function(k,v) {
		$(v).slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows: false,
			pauseOnHover: false
		});
	});

	$('.slider-event').each(function(k,v) {
		$(v).slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			pauseOnHover: false
		});
	});

	$('.slider-sponsors-banner').each(function(k,v) {
		$(v).slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: false,
			pauseOnHover: false,
			responsive: [
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: false,
						autoplay: true,
						autoplaySpeed: 10000,
						arrows: false,
						pauseOnHover:false
					}
				}
			]
		});
	});

	$('.slider-webinars').each(function(k,v) {
		$(v).slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
		});
	});

	$('.slider-partners-banner').each(function(k,v) {
		$(v).slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			pauseOnHover:false,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: true,
						dots: false,
						autoplay: true,
						autoplaySpeed: 3000,
						arrows: false,
						pauseOnHover:false
					}
				}
			]

		});
	});

	$('form.wpcf7-form').on('submit', function(e){
		var $form = e.target;
		$('.hide-on-subscribe').hide();
		$($form).replaceWith("<p class=\"newsletter-thankyou\">Many thanks for signing up – we’ll start sending the EME update out to you soon</p>");
	});

	$('.toggle-inner').on('click', function(e){
		var $target = e.target;
		var $parent = $($target).closest('button');
		var $form = $($parent).find('form');
		$($form).trigger("submit");
	});

	$('#showNewsletterForm').on('click', function(e){
		var $target = e.target;
		$($target).hide();
		$('#newsletterPopupFormWrapper').show();
	});

	$('.close-popup').on('click', function(e){
		$("#modalnewsletter").hide();
		$("#modalBkg").hide();
		setCookie("showNewsletter", "false", 365);
	});

	window.setTimeout(showNewsletter, 30000);
});

function showNewsletter() {
	var test = getCookie("showNewsletter")
	if(test !== "false"){
		$("#modalnewsletter").show();
		$("#modalBkg").show();
	}
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
